import React, { useState } from "react";
import { Link } from "react-router-dom";

const BannerSimple = () => {
  const [showHpPopup, setShowHpPopup] = useState(false);

  const hpUrl = "#";

  return (
    <section
      className="sx-hero"
      style={{ backgroundImage: "url('/assets/images/bg/printer.jpg')" }}
    >
      <div className="sx-hero-overlay"></div>

      <div className="sx-hero-wrap">
        {/* LEFT */}
        <div className="sx-hero-text">
          <span className="sx-hero-tag">Smart Printing Solutions</span>

          <h1 className="sx-hero-heading">
            Powerful Printers <br />
            Built for Modern Needs
          </h1>

          <p className="sx-hero-sub">
            Reliable printing solutions for home users, growing businesses, and
            enterprise workflows — engineered for speed and quality.
          </p>

          <div className="sx-hero-actions">
            <Link to="/shop" className="sx-btn-primary">
              Browse Printers
            </Link>
            <Link to="/book-an-appointment" className="sx-btn-outline">
              Book an Appointment
            </Link>
          </div>

          {/* HP PARTNER (ADDED BELOW BUTTONS) */}
          <div className="sx-hp-row">
            <img
              src="/assets/hp-partner.png"
              alt="HP Business Partner"
              className="sx-hp-logo"
            />
          </div>
        </div>

        {/* RIGHT */}
        <div className="sx-hero-visual">
          <img src="/assets/images/bg/banner3.png" alt="Printer" />
        </div>
      </div>

      {/* HP POPUP */}
      {showHpPopup && (
        <div className="sx-popup-overlay">
          <div className="sx-popup-box">
            <p className="sx-popup-text">
              You’re being redirected to the HP partner directory at{" "}
              <strong>locator.hp.com</strong>
            </p>
            <div className="sx-popup-actions">
              <button
                className="sx-popup-proceed"
                onClick={() => {
                  window.open(hpUrl, "_blank");
                  setShowHpPopup(false);
                }}
              >
                Proceed
              </button>
              <button
                className="sx-popup-cancel"
                onClick={() => setShowHpPopup(false)}
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}

      {/* CSS */}
      <style>{`
        /* ================= HERO ================= */
        .sx-hero {
          height: 640px;
          background-size: cover;
          background-position: center;
          position: relative;
          display: flex;
          align-items: center;
        }

        .sx-hero-overlay {
          position: absolute;
          inset: 0;
          background: linear-gradient(
            to right,
            rgba(0,0,0,0.9),
            rgba(0,0,0,0.65)
          );
        }

        .sx-hero-wrap {
          position: relative;
          z-index: 2;
          max-width: 1300px;
          margin: auto;
          padding: 0 20px;
          display: flex;
          align-items: center;
          justify-content: space-between;
          gap: 40px;
        }

        /* TEXT */
        .sx-hero-text {
          max-width: 55%;
          color: #fff;
        }

        .sx-hero-tag {
          display: inline-block;
          font-size: 13px;
          color: #0b5ed7;
          font-weight: 600;
          letter-spacing: 1px;
          margin-bottom: 14px;
        }

        .sx-hero-heading {
          font-size: 58px;
          font-weight: 700;
          line-height: 1.1;
          margin-bottom: 18px;
          color: #fff;
        }

        .sx-hero-sub {
          font-size: 18px;
          color: #d1d5db;
          max-width: 520px;
          margin-bottom: 36px;
        }

        /* ACTIONS */
        .sx-hero-actions {
          display: flex;
          gap: 18px;
        }

        .sx-btn-primary {
          padding: 14px 36px;
          background: #0b5ed7;
          color: #fff;
          text-decoration: none;
          font-size: 15px;
          font-weight: 600;
          transition: .3s;
        }

        .sx-btn-primary:hover {
          background: #084bb0;
          color:white;
        }

        .sx-btn-outline {
          padding: 14px 36px;
          border: 2px solid #0b5ed7;
          color: #fff;
          text-decoration: none;
          font-size: 15px;
          font-weight: 500;
          transition: .3s;
        }

        .sx-btn-outline:hover {
          background: #0b5ed7;
          color:white;
        }

        /* HP PARTNER */
        .sx-hp-row {
          margin-top: 22px;
        }

        .sx-hp-logo {
          width: 150px;
          cursor: pointer;
        }

        /* IMAGE */
        .sx-hero-visual img {
          width: 420px;
          filter: drop-shadow(0 20px 40px rgba(0,0,0,.5));
          animation: sxFloat 5s ease-in-out infinite;
        }

        @keyframes sxFloat {
          0%,100% { transform: translateY(0); }
          50% { transform: translateY(-14px); }
        }

        /* POPUP */
        .sx-popup-overlay {
          position: fixed;
          inset: 0;
          background: rgba(0,0,0,0.65);
          display: flex;
          align-items: center;
          justify-content: center;
          z-index: 9999;
        }

        .sx-popup-box {
          background: #111;
          padding: 24px;
          border-radius: 12px;
          max-width: 380px;
          text-align: center;
        }

        .sx-popup-text {
          color: #ffffff;
          font-size: 15px;
        }

        .sx-popup-actions {
          display: flex;
          gap: 12px;
          margin-top: 18px;
        }

        .sx-popup-actions button {
          flex: 1;
          padding: 10px;
          border-radius: 6px;
          border: none;
          cursor: pointer;
        }

        .sx-popup-proceed {
          background: #0071ce;
          color: #ffffff;
        }

        .sx-popup-cancel {
          background: #e5e7eb;
          color: #000;
        }

        /* MOBILE */
        @media(max-width: 900px) {
          .sx-hero {
            height: auto;
            padding: 80px 0;
          }

          .sx-hero-wrap {
            flex-direction: column;
            text-align: center;
          }

          .sx-hero-text {
            max-width: 100%;
          }

          .sx-hero-heading {
            font-size: 36px;
          }

          .sx-hero-visual {
            display: none;
          }

          .sx-hero-actions {
            justify-content: center;
            flex-wrap: wrap;
          }

          .sx-hp-row {
            display: flex;
            justify-content: center;
          }
        }
      `}</style>
    </section>
  );
};

export default BannerSimple;
